var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isClient)?_c('q-btn',{attrs:{"icon":"far fa-question-circle","label":"Help","color":"accent","flat":""},on:{"click":_vm.open}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }